/// <reference types="vite/client" />
var env;
var BING_MAPS_API_KEY = 'AtOErP6G4iFim0YKBl---ImAHmDWA_JBrJ3HIeyPY92QF5yiu_5Ex21DdeB4D7LT';
var FACEBOOK_APP_ID = '431351161866019'; // In vite mode, process.env.NODE_ENV exists but process is undefined
// In nextJs mode, 'process.env.TEST' is text replaced to whatever the value is in env variables and process is defined

if (typeof process !== 'undefined') {
  if (process.env.NEXT_PUBLIC_BING_MAPS_API_KEY) BING_MAPS_API_KEY = process.env.NEXT_PUBLIC_BING_MAPS_API_KEY;
  if (process.env.NEXT_PUBLIC_FACEBOOK_APP_ID) FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID;
} else if (import.meta !== undefined) {
  env = import.meta.env;
  if (env.VITE_PUBLIC_BING_MAPS_API_KEY) BING_MAPS_API_KEY = env.VITE_PUBLIC_BING_MAPS_API_KEY;
  if (env.VITE_PUBLIC_FACEBOOK_APP_ID) FACEBOOK_APP_ID = env.VITE_PUBLIC_FACEBOOK_APP_ID;
} else {
  throw 'No env found';
}

export { BING_MAPS_API_KEY, FACEBOOK_APP_ID };